var sw = sw || {};

// Custom Cursor
//-----------------------------------------------------------------
sw.customCursor = function() {

    var cursor = $(".cursor"),
        follower = $(".cursor__follower");

    var posX = 0,
        posY = 0;

    var mouseX = 0,
        mouseY = 0;

    gsap.to({}, 0.016, {
      repeat: -1,
      onRepeat: function() {
        posX += (mouseX - posX) / 9;
        posY += (mouseY - posY) / 9;
        
        gsap.set(follower, {
            css: {    
            left: posX - 5,
            top: posY - 5
            }
        });
        
        gsap.set(cursor, {
            css: {    
            left: mouseX,
            top: mouseY
            }
        });
      }
    });

    $(document).on("mousemove", function(e) {
        mouseX = e.clientX;
        mouseY = e.clientY;
    });

    $("a").on("mouseenter", function() {
        cursor.addClass("active");
        follower.addClass("active");
    });
    $("a").on("mouseleave", function() {
        cursor.removeClass("active");
        follower.removeClass("active");
    });

    $("button").on("mouseenter", function() {
        cursor.addClass("active");
        follower.addClass("active");
    });
    $("button").on("mouseleave", function() {
        cursor.removeClass("active");
        follower.removeClass("active");
    });

    $(".swiper-button-prev").on("mouseenter", function() {
        cursor.addClass("active");
        follower.addClass("active");
    });
    $(".swiper-button-prev").on("mouseleave", function() {
        cursor.removeClass("active");
        follower.removeClass("active");
    });

    $(".swiper-button-next").on("mouseenter", function() {
        cursor.addClass("active");
        follower.addClass("active");
    });
    $(".swiper-button-next").on("mouseleave", function() {
        cursor.removeClass("active");
        follower.removeClass("active");
    });


}

$(document).ready(function (){
    sw.customCursor();
});